import React from "react";

import Section from "../../../HOC/Section";

const Service = () => {
  return (
    <Section id="services">
      <div className="container pt-2 pb-5">
        <div className="section-header pt-5 pb-5 text-center">
          <h3 className="section-title">
            <span>UBC </span>轴承介绍
          </h3>
          <h6 className="section-subtitle mr-auto ml-auto">
            Individualized quality care that meets the total needs of the
            patient Individualized quality care that quality care that
            Individualized quality care that meets the total.
          </h6>
        </div>
        <div className="section-content">
          <div className="row">
            <div className="col-md-6 col-lg-4 mb-3">
              <div className="service-box d-flex">
                <div className="service-icon mr-4">
                  <i className="fas fa-briefcase" />
                </div>
                <div className="service-body">
                  <h5 className="service-title">研究设计</h5>
                  <p className="service-description">
                    设计研发中心以坚持基础性研究、应用性研究和 产业
                    化研究三元融合，引领我国高端精密、高速、 重载轴
                    承的技术升级”这一技术中心总体目标。
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 mb-3">
              <div className="service-box d-flex">
                <div className="service-icon mr-4">
                  <i className="fas fa-chart-bar" />
                </div>
                <div className="service-body">
                  <h5 className="service-title">生产</h5>
                  <p className="service-description">
                    UBC 工厂拥有先进的、自动化的、 高精度生产设备;将全面推向智
                    能制造。
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 mb-3">
              <div className="service-box d-flex">
                <div className="service-icon mr-4">
                  <i className="fas fa-fist-raised" />
                </div>
                <div className="service-body">
                  <h5 className="service-title">品质检测</h5>
                  <p className="service-description">
                    三丰圆度仪/MITUTOYO roundness tester
                    圆度、圆柱度、同轴度、平行度、垂直度检测 测量范围 开拓 创新
                    外径150mm以下、主轴径向跳动0.02um
                  </p>
                </div>
              </div>
            </div>
            {/* <div className="col-md-6 col-lg-4 mb-3">
              <div className="service-box d-flex">
                <div className="service-icon mr-4">
                  <i className="far fa-paper-plane" />
                </div>
                <div className="service-body">
                  <h5 className="service-title">Market Research</h5>
                  <p className="service-description">
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 mb-3">
              <div className="service-box d-flex">
                <div className="service-icon mr-4">
                  <i className="fas fa-gem" />
                </div>
                <div className="service-body">
                  <h5 className="service-title">Business Financing</h5>
                  <p className="service-description">
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 mb-3">
              <div className="service-box d-flex">
                <div className="service-icon mr-4">
                  <i className="far fa-life-ring" />
                </div>
                <div className="service-body">
                  <h5 className="service-title">Suppport Team</h5>
                  <p className="service-description">
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Service;
